module.exports = __webpack_public_path__ + "static/media/lineString.be2b15f4.svg";